module.exports = __webpack_public_path__ + "img/youtube.26504922.svg";